export enum SparrowAppEnum {
  CustomerApproval = 'CUSTOMER_APPROVAL',
  StockManagement = 'STOCK_MANAGEMENT',
  Planning = 'PLANNING',
  Pool = 'POOL',
}

export const SparrowAppOptions = Object.keys(SparrowAppEnum);

export enum CustomAppEnum {
  Ca = 'CA',
  Dc = 'DC',
  Sm = 'SM',
}
